<template>
  <div class="fetch-by-id-panel">
    <button
      class="fetch-by-id-panel__close"
      @click="$emit('close')"
    >
      &times;
    </button>
    <p class="fetch-by-id-panel__title">
      Fetch by ID
    </p>

    <div class="fetch-by-id-panel__tabs">
      <button
        :class="['fetch-by-id-panel__tab', activeTab === 'asin' ? 'active' : '']"
        @click="activeTab = 'asin'"
      >
        ASIN
      </button>
      <!-- <button
        disabled
        :class="['fetch-by-id-panel__tab', activeTab === 'salsify' ? 'active' : '']"
        @click="activeTab = 'salsify'"
      >
        Salsify ID
      </button> -->
    </div>

    <div class="fetch-by-id-panel__input-row">
      <input
        v-model="query"
        class="fetch-by-id-panel__input"
        placeholder="B08XYZ1234"
        :disabled="loading"
        @keydown.enter="fetch"
      >
      <button
        class="fetch-by-id-panel__fetch-btn"
        :disabled="loading || !query.trim()"
        @click="fetch"
      >
        <span v-if="loading">
          <b-spinner small />
        </span>
        <span v-else>Fetch</span>
      </button>
    </div>

    <p class="fetch-by-id-panel__hint">
      Pulls primary image from Amazon and adds it to the grid.
    </p>

    <p
      v-if="error"
      class="fetch-by-id-panel__error"
    >
      {{ error }}
    </p>
  </div>
</template>

<script>
import FileBrowser from '@frontend/services/api/file-browser';

export default {
  name: 'FetchByIdModal',
  data: () => ({
    activeTab: 'asin',
    query: '',
    loading: false,
    error: null,
  }),
  methods: {
    async fetch() {
      this.error = null;

      if (!this.query.trim()) {
        return;
      }

      this.loading = true;

      try {
        await this.fetchAsin();
      } finally {
        this.loading = false;
      }
    },

    async fetchAsin() {
      const asin = this.query.trim().toUpperCase();

      try {
        const { data } = await FileBrowser.fetchAsinImage(asin);
        const item = {
          id: `asin:${asin}`,
          fileId: `asin:${asin}`,
          name: data.name,
          type: 'image',
          full_url: data.url,
          thumbnail: data.url,
          path: data.url,
          original_path: data.url,
          count: 0,
        };
        this.$emit('item-fetched', item);
        this.query = '';
      } catch (e) {
        this.error = e?.response?.data?.error || 'Failed to fetch image for this ASIN.';
      }
    },

    // async fetchSalsify() {
    //   try {
    //     const data = await FileBrowser.getSalsifyProduct({ salsify_id: this.query.trim() });
    //     this.$emit('item-fetched', data);
    //     this.query = '';
    //   } catch (e) {
    //     this.error = 'Failed to fetch Salsify product.';
    //   }
    // },
  },
};
</script>

<style scoped lang="scss">
.fetch-by-id-panel {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  padding: 16px;
  width: 320px;
  position: absolute;
  top: 55px;
  right: 50px;
  z-index: 1000;

  &__close {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 22px;
    height: 22px;
    border: none;
    background: transparent;
    font-size: 18px;
    line-height: 1;
    color: #999;
    cursor: pointer;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      color: #333;
    }
  }

  &__title {
    font-weight: 600;
    font-size: 14px;
    margin-bottom: 12px;
  }

  &__tabs {
    display: inline-flex;
    border: 1px solid #d0d0d0;
    border-radius: 6px;
    padding: 3px;
    margin-bottom: 12px;
    background: #f5f5f5;
  }

  &__tab {
    padding: 0px 12px;
    border: 1px solid transparent;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 500;
    color: #999;
    background: transparent;
    cursor: pointer;
    transition: color 0.15s, border-color 0.15s, background 0.15s;

    &.active {
      border-color: transparent;
      color: #111;
      background: #fff;
    }

    // &:not(.active):hover {
    //   color: #555;
    // }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }

  &__input-row {
    display: flex;
    gap: 8px;
    margin-bottom: 8px;
  }

  &__input {
    flex: 1;
    border: 1px solid #ccc;
    border-radius: 6px;
    padding: 6px 10px;
    font-size: 12px;

    &:focus {
      outline: none;
      border-color: #6dbfb8;
    }
  }

  &__fetch-btn {
    padding: 6px 16px;
    background: #209c86;
    color: #fff;
    border: none;
    border-radius: 6px;
    font-size: 12px;
    cursor: pointer;
    white-space: nowrap;

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }

    &:hover:not(:disabled) {
      background: #5aada6;
    }
  }

  &__hint {
    font-size: 12px;
    // color: #6dbfb8;
    margin-bottom: 0;
  }

  &__error {
    font-size: 12px;
    color: #e74c3c;
    margin-top: 6px;
    margin-bottom: 0;
  }
}
</style>
